"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePrefetch = exports.useRouteParam = exports.useQuery = exports.useRouter = void 0;
var react_1 = require("react");
var router_1 = require("./contexts/router");
var helpers_1 = require("./helpers");
/**
 * Get a value from the router.query and set it's type.
 * @param router Next router
 * @param key Query value
 */
function getQuery(router, key) {
    return router.query[key];
}
/**
 * A replacement for useRouter from Next.js. This returns a modified API that accepts Route objects and some helper
 * functions for generating links, click handlers, and hrefs.
 */
function useRouter() {
    var router = (0, react_1.useContext)(router_1.RouterContext);
    if (!router) {
        throw new Error('Missing <RouterContext>');
    }
    return (0, react_1.useMemo)(function () {
        return {
            router: router,
            getQuery: function (key) {
                return getQuery(router, key);
            },
            pushRoute: function (route, options) { return (0, helpers_1.pushRoute)(router, route, options); },
            replaceRoute: function (route, options) { return (0, helpers_1.replaceRoute)(router, route, options); },
            createLink: function (route, options) { return (0, helpers_1.createLink)(router, route, options); },
            createHref: function (route) { return (0, helpers_1.routeToString)(router, route); },
            createClickHandler: function (route, options) { return (0, helpers_1.createClickHandler)(router, route, options); },
            isRouteActive: function (route) { return router.route.startsWith(route.pathname); },
        };
    }, [router]);
}
exports.useRouter = useRouter;
/**
 * Get a URL param or query value.
 * @param key Query param name
 */
function useQuery(key) {
    var router = useRouter().router;
    return getQuery(router, key);
}
exports.useQuery = useQuery;
/**
 * Get a route parameter. This will throw if the route parameter doesn't exist.
 * @param key
 */
function useRouteParam(key) {
    var router = useRouter().router;
    var params = (0, helpers_1.findParams)(router.route);
    if (!params.includes(key)) {
        throw new Error("The current page route does not contain the parameter \"" + key + "\". Did you mispell it?");
    }
    var value = getQuery(router, key);
    if (!value) {
        throw new Error("Route parameter \"" + key + "\" doesn\u2019t exist");
    }
    return value;
}
exports.useRouteParam = useRouteParam;
/**
 * Prefetch the JS bundles for a route
 * @param route
 */
function usePrefetch(route) {
    var router = useRouter().router;
    (0, react_1.useEffect)(function () {
        if (route) {
            router.prefetch(route.pathname);
        }
    }, [route && route.pathname]);
}
exports.usePrefetch = usePrefetch;
